﻿(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Util = {};

    function handleOrientationChange() {
        window.addEventListener("resize", function (event) {
            M2.Util.removeProgressBar();
            window.setTimeout(function () {
                M2.Util.setProgressBar();
            }, 100);
        });
    }

    function changeLanguage() {
        $(document).on("click", ".language a", function (e) {
           // e.preventDefault();
            M2.Util.config.language = $(this).data("language");
        });  
    }

    function setTheme() {
        const isGSA = $('body').hasClass('store-gsa');
        const isFunderworks = $('body').hasClass('store-school');
        const isWFC = $('body').hasClass('store-wfc');
        const isGivingMarket = $('body').hasClass('store-gm');
        const theme = isGSA ? "gsa" : isFunderworks ? "school" : isWFC ? "wfc" : isGivingMarket ? "gm" : "";
        M2.Util.config.theme = theme;
    }

    function setInputMasks() {
        $('body').on("focus", ".telephone input[type=text]:not(.inactive)", function () {
            $(this).mask('000-000-0000');
        });
    }

    function setConfigOptions() {
        // Set config options
        /* global M2_Util_pathToImages */
        if ('undefined' !== typeof M2_Util_pathToImages) M2.Util.config.pathToImages = M2_Util_pathToImages;
    }

    M2.Util = {
        config: {
            name: "M2 Fundraising Utilities",
            pathToImages: "",
            language: "en",
            theme: "gsa"
        },
        isMobile: {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (M2.Util.isMobile.Android() || M2.Util.isMobile.BlackBerry() || M2.Util.isMobile.iOS() || M2.Util.isMobile.Opera() || M2.Util.isMobile.Windows());
            }
        },
        init: function () {
            changeLanguage();
            M2.Util.setSwitches();
            M2.Util.setProgressBar();
            setTheme();
            setInputMasks();
            handleOrientationChange();
            setConfigOptions();
            this.setImageSelect();
        },
        setImageSelect: function () {
            $(".image-select").selectBoxIt({
                autoWidth: false, theme: "jqueryui"
            }).bind({
                "open": function (ev, obj) {
                    M2.Modal.resizeParentIframe();
                },
                "close": function (ev, obj) {
                    M2.Modal.resizeParentIframe();
                }
            });

        },
        setSwitches: function () {
            var elems = Array.prototype.slice.call(document.querySelectorAll('.switch'));
            var switchery;

            elems.forEach(function (html) {
                /* global Switchery */
                if ($(html).is('[readonly]')) {
                    switchery = new Switchery(html, { disabled: true });
                } else {
                    switchery = new Switchery(html);
                }

            });
        },
        exists: function (elem) {
            if (elem.length > 0) return true;
        },
        clearSearchBox: function (target, defaultText) {
            $(target).click(function () {
                if ($(this).val() == defaultText) $(this).val('');
            });
        },
        setProgressBar: function () {

            $(function () {
                $('.goal-thermometer').each(function () {
                    var rawValue = $(this).data('val');
                    // If it's a string remove the commas
                    if (typeof rawValue === 'string') {
                        if (rawValue.indexOf(',') > -1) {
                            rawValue = rawValue.replace(/,\s?/g, "");
                        }
                    }
                    var value = parseInt(rawValue);
                    var maxValue = 150;
                    $(this).progressbar({ value: value, max: maxValue });
                });
            });
        },
        removeProgressBar: function () {
            $('.goal-thermometer').each(function () {
                if ($(this).progressbar('instance') !== undefined) $(this).progressbar('destroy');
            });
        },
        stopMediaPlayer: function () {
            // Stop any videos that are playing
            try {
                //Loop and Stop
                let i;
                const videoPlayers = M2.Video.getAllPlayers();
                for (var key in videoPlayers) {
                    videoPlayers[key].pause();
                }
            } catch (err) {
                console.log(err.message);
            }
        },
        displayLoad: function (target, content) {
            const loadingText = (content) ? "<h5>" + content + "</h5>" : "";

            const loadingGraphicTemplate = `
                <div class='loading-graphic'>
                    ${loadingText}<img src="${this.config.pathToImages}loading-bar.gif" alt="Loading" />
                </div>
            `;
            $(target).html(loadingGraphicTemplate);
        },
    };
})(jQuery);

$(function () {
    M2.Util.init();
});